import React from 'react';
import styles from './style.module.scss';
import logoDark from './logoDark.svg';
import logoLight from './logoLight.svg';
import logoLightBc from './logoLightBc.svg';
import logoDarkBc from './logoDarkBc.svg';
import { withThemeVariant } from '../../provider/ThemeProvider/index';

/**
 * The TruckJobs logo
 *
 * @param {logoVariant} variant The logos variant
 * @param {logoSizes}   size    The logos size
 **/
export var Logo = function Logo(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'light' : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'responsive' : _ref$size,
      _ref$globalThemeVaria = _ref.globalThemeVariant,
      globalThemeVariant = _ref$globalThemeVaria === void 0 ? 'pc' : _ref$globalThemeVaria;
  return React.createElement("span", {
    className: "".concat(styles.logoWrapper, " ").concat(styles[size])
  }, React.createElement("img", {
    alt: "TruckJobs",
    src: variant === 'dark' && globalThemeVariant === 'bc' ? logoDarkBc : variant === 'light' && globalThemeVariant === 'bc' ? logoLightBc : variant === 'dark' ? logoDark : logoLight
  }));
};
export default withThemeVariant(Logo);